import styled from "styled-components";

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 0.5rem;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
`;

export const DashboardContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

export const StatCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  flex: 1;
  min-width: 220px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e9ecef;
  }
`;

export const StatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: #343a40;
`;

export const StatLabel = styled.div`
  margin-top: 0.5rem;
  font-size: 1rem;
  color: #6c757d;
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.6rem;
  margin: 2rem 0 1rem;
  color: #343a40;
`;
